import React, { useEffect, useState, useMemo, useRef } from "react";
import { MaterialReactTable } from "material-react-table";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Controller, useForm } from "react-hook-form";
import AssessmentDateModal from "./AssessmentDateModal";
import PayRegChallanModal from "./PayRegChallanModal";
import AssessmentMarksModal from "./AssessmentMarksModal";
import InterviewModal from "./InterviewModal";
import ReviewDetailsModal from "./ReviewDetailsModal";
import useAdmissionChallanPdf from "../../hooks/useAdmissionChallanPdf";
import FullScreenLoader from "../../components/FullScreenLoader";
import PayAdmissionChallanModal from "./PayAdmissionChallanModal";
import ScheduleInterviewModal from "./ScheduleInterviewModal";
import CampusNewRegistrationModel from "./CampusNewRegistrationModal";
import { useChat } from "../../context/ChatContext";
import AskConfirmationModal from "../../components/modals/AskConfirmationModal";
import StatusRegistrationModal from "./StatusRegistrationModal";
import { useWorkflow } from "../../context/WorkflowContext";
import WorkflowProcessIds from "../../constants/WorkflowProcessIdsEnum";
import DBObjectIds from "../../constants/DBObjectsIdsEnum";
import StagePopup from "../dashboard/StagePopup"; // Corrected import path
import RegPaymentProofModal from "../../components/modals/RegPaymentProofModal";
import NotificationEventTypes from "../../constants/notificationEventsEnum";

function RegistrationsList() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const centerId = localStorage.getItem("centerId");
  const userId = localStorage.getItem("userId");
  const roleId = localStorage.getItem("roleId");
  const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false);
  const { openChatWithReceiver } = useChat();
  const { workflowParams, setWorkflowParams } = useWorkflow();
  const [showPopup, setShowPopup] = useState(false); // New state for popup
  const hasPopupBeenShown = useRef(false);
  const [regPaymentProofModalData, setRegPaymentProofModalData] =
    useState(null);
  const [paymentProofType, setPaymentProofType] = useState("");
  useState(false);
  const [showRegPaymentProofModal, setShowRegPaymentProofModal] =
    useState(false);

  const {
    register,
    watch,
    control,
    handleSubmit,
    setValue,
    getValues,
    reset,
    trigger,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useForm();

  const [columnLabels, setColumnLabels] = useState({});
  const [registrationsData, setRegistrationsData] = useState([]);
  const [workflowSteps, setWorkflowSteps] = useState({});
  const [nextSteps, setNextSteps] = useState({});
  const [tablePreferences, setTablePreferences] = useState(null);
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [sorting, setSorting] = useState([]);
  const [columnSizing, setColumnSizing] = useState({});
  const [filterModes, setFilterModes] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const [modalMode, setModalMode] = useState("acceptance");

  const navigate = useNavigate();

  const [dateValue, setDateValue] = useState("");
  const [isAssessmentDateModalVisible, setIsAssessmentDateModalVisible] =
    useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [triggerRerender, setTriggerRerender] = useState(false);
  const [classesData, setClassesData] = useState([]);
  const [showPayRegModal, setShowPayRegModal] = useState(false);
  const [payRegModalData, setPayRegModalData] = useState(null);
  const [showPayAdmissionModal, setShowPayAdmissionModal] = useState(false);
  const [payAdmissionModalData, setPayAdmissionModalData] = useState(null);
  const [isAssessmentMarksModalVisible, setIsAssessmentMarksModalVisible] =
    useState(false);
  const [isScheduleInterviewModalVisible, setIsScheduleInterviewModalVisible] =
    useState(false);
  const [isInterviewModalVisible, setIsInterviewModalVisible] = useState(false);
  const [assessmentData, setAssessmentData] = useState([]);
  const [assessmentDate, setAssessmentDate] = useState("");
  const [isReviewDetailsModalVisible, setIsReviewDetailsModalVisible] =
    useState(false);
  const [isStatusModalVisible, setIsStatusModalVisible] = useState(false);
  const [isNewRegistrationModel, setNewRegistrationModel] = useState(false);
  const [VerifyAccountId, setVerifyAccountId] = useState(null);
  const [VerifyAccountChallanId, setVerifyAccountChallanId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [workflowStatus, setWorkflowStatus] = useState({});
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const closeStatusModal = () => {
    setIsStatusModalOpen(false);
    setSelectedRowId(null);
  };

  const getRegistrationsList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    try {
      const response = await get(
        `Student/GetStudentFirstRegistrationByOrgIdAndCenterId?organizationId=${organizationId}&centerId=${centerId}&date=${dateValue}&userId=${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response) {
        setRegistrationsData(response?.data);
        setColumnLabels(
          Object.fromEntries(
            response?.columns.map((col) => [col.key, col.label])
          )
        );
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      console.error("Error fetching Centers:", error);
    }
  };

  const fetchWorkflowSteps = async (ids) => {
    if (!ids.length) return;
    try {
      const payload = {
        ProcessId: WorkflowProcessIds.NewRegistration,
        DBObjectId: DBObjectIds.StudentFirstRegistrations,
        DBObjectLocationIds: ids.join(","),
        UserId: Number(localStorage.getItem("userId")),
        RoleId: Number(localStorage.getItem("roleId")),
      };
      const response = await post(`workflow/getNextStepInfo`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.success) {
        const stepMap = Object.fromEntries(
          response.workflowStepInfoByRecordList.map((step) => [
            step.recordId,
            {
              id: step.nextStepId,
              name: step.nextStep,
              icon: step.nextStepIcon,
            },
          ])
        );
        setWorkflowSteps(stepMap);
      } else {
        toast.error(response.message || "Failed to fetch workflow steps");
      }
    } catch (error) {
      console.error("Error fetching workflow steps:", error);
      toast.error("Failed to fetch workflow steps");
    }
  };

  const fetchWorkflowStatus = async (ids) => {
    if (!ids.length) return;
    try {
      const payload = {
        ProcessId: WorkflowProcessIds.NewRegistration,
        DBObjectId: DBObjectIds.StudentFirstRegistrations,
        DBObjectLocationIds: ids.join(","),
      };
      const response = await post(`workflow/getStepsStatus`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.success) {
        const statusMap = {};
        response.workflowStepsStatusList.forEach((status) => {
          if (!statusMap[status.RecordId]) {
            statusMap[status.RecordId] = [];
          }
          statusMap[status.RecordId].push(status);
        });
        setWorkflowStatus(statusMap);
      } else {
        toast.error(response.message || "Failed to fetch workflow status");
      }
    } catch (error) {
      console.error("Error fetching workflow status:", error);
      toast.error("Failed to fetch workflow status");
    }
  };

  const fetchNextSteps = async (ids) => {
    if (!ids.length) return;
    try {
      const payload = {
        ProcessId: WorkflowProcessIds.NewRegistration,
        DBObjectId: DBObjectIds.StudentFirstRegistrations,
        DBObjectLocationIds: ids.join(","),
      };
      const response = await post(`workflow/getNextStepByRecordId`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.success) {
        const nextStepMap = Object.fromEntries(
          response.data.map((step) => [
            step.RecordId,
            {
              nextStep: step.NextStep,
              isEnd: step.IsEnd,
              nextStepAction: step.NextStepAction,
              nextStepRole: step.NextStepRole,
            },
          ])
        );
        setNextSteps(nextStepMap);
      } else {
        toast.error(response.message || "Failed to fetch next steps");
      }
    } catch (error) {
      console.error("Error fetching next steps:", error);
      toast.error("Failed to fetch next steps");
    }
  };

  const fetchTablePreferences = async () => {
    try {
      const response = await get(
        `CommonSettings/GetDatatablePreferences?userId=${userId}&TableName=registrationsListing`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const defaultFilterModes = Object.fromEntries(
        response.columnOrder.map((key) => [
          key,
          key.includes("Id") || key.includes("No") || key.startsWith("is")
            ? "equals"
            : key.includes("Date")
            ? "between"
            : "contains",
        ])
      );
      const preferences = {
        columnOrder: response.columnOrder || [],
        columnVisibility: response.columnVisibility || {},
        columnSortability: response.columnSortability || {},
        columnSorting: response.columnSorting || [],
        columnFilterability: response.columnFilterability || {},
        columnWidths: Object.fromEntries(
          Object.entries(response.columnWidths || {}).map(([key, value]) => [
            key,
            value || 150,
          ])
        ),
        columnFilterModes: response.columnFilterModes || defaultFilterModes,
      };
      setTablePreferences(preferences);
      setColumnOrder([...preferences.columnOrder, "status"]);
      setColumnVisibility({ ...preferences.columnVisibility, status: true });
      setSorting(preferences.columnSorting.slice(0, 1));
      setColumnSizing({ ...preferences.columnWidths, status: 200 });
      setFilterModes({ ...preferences.columnFilterModes, status: "contains" });
    } catch (error) {
      console.error("Error fetching table preferences:", error);
      toast.error("Failed to fetch table preferences");
    }
  };

  const saveTablePreferences = async () => {
    try {
      const filteredColumnSizing = Object.fromEntries(
        Object.entries(columnSizing)
          .filter(
            ([key]) =>
              key !== "mrt-row-spacer" && key !== "actions" && key !== "status"
          )
          .map(([key, value]) => [key, Math.max(value, 50)])
      );
      const preferences = {
        columnOrder: columnOrder.filter(
          (key) =>
            key !== "mrt-row-spacer" && key !== "actions" && key !== "status"
        ),
        columnVisibility: Object.fromEntries(
          Object.entries(columnVisibility).filter(
            ([key]) =>
              key !== "mrt-row-spacer" && key !== "actions" && key !== "status"
          )
        ),
        columnSortability: Object.fromEntries(
          Object.entries(tablePreferences.columnSortability).filter(
            ([key]) =>
              key !== "mrt-row-spacer" && key !== "actions" && key !== "status"
          )
        ),
        columnSorting: sorting
          .filter((s) => s.id !== "actions")
          .map((s) => ({
            id: s.id,
            desc: s.desc === "True" || s.desc === true,
          })),
        columnFilterability: Object.fromEntries(
          Object.entries(tablePreferences.columnFilterability).filter(
            ([key]) =>
              key !== "mrt-row-spacer" && key !== "actions" && key !== "status"
          )
        ),
        columnWidths: filteredColumnSizing,
        columnFilterModes: Object.fromEntries(
          Object.entries(filterModes).filter(
            ([key]) =>
              key !== "mrt-row-spacer" && key !== "actions" && key !== "status"
          )
        ),
      };
      const payload = { userId, tableId: "registrationsListing", preferences };
      const response = await post(
        `CommonSettings/SaveDatatableFiters`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success("Preferences saved successfully");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error saving preferences:", error);
      toast.error(`Failed to save preferences: ${error.message}`);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    await Promise.all([getRegistrationsList(), fetchTablePreferences()]);
    setLoading(false);
    if (registrationsData.length) {
      const ids = registrationsData.map((row) => row.id);
      await Promise.all([
        fetchWorkflowSteps(ids),
        fetchWorkflowStatus(ids),
        fetchNextSteps(ids),
      ]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dateValue, triggerRerender]);

  useEffect(() => {
    if (registrationsData.length) {
      const ids = registrationsData.map((row) => row.id);
      Promise.all([
        fetchWorkflowSteps(ids),
        fetchWorkflowStatus(ids),
        fetchNextSteps(ids),
      ]);
    }
  }, [registrationsData]);

  useEffect(() => {
    if (
      registrationsData.length > 0 &&
      Object.keys(workflowStatus).length > 0 &&
      Object.keys(nextSteps).length > 0 &&
      !hasPopupBeenShown.current
    ) {
      setShowPopup(true);
      hasPopupBeenShown.current = true;
    }
  }, [registrationsData, workflowStatus, nextSteps]);

  const handleCloseModal = () => {
    setIsConfimationModalOpen(false);
    setVerifyAccountId(null);
    setVerifyAccountChallanId(null);
  };

  const navigateToReview = (userId) => {
    navigate(`/registration-form?userId=${userId}`);
  };

  const openReviewDetailsModalCEO = (row) => {
    setSelectedRow(row);
    setModalMode("ceoApproval");
    setIsReviewDetailsModalVisible(true);
  };

  const openReviewDetailsModalAccounts = (row) => {
    setSelectedRow(row);
    setModalMode("accountsApproval");
    setIsReviewDetailsModalVisible(true);
  };

  const VerifyAccountChallan = async (id, challanId) => {
    setVerifyAccountId(id);
    setVerifyAccountChallanId(challanId);
    setIsConfimationModalOpen(true);
  };

  const VerifyAccountChallanA = async () => {
    try {
      const response = await get(
        `AssessmentType/VerifyRegistrationChallans?Id=${VerifyAccountId}&challanId=${VerifyAccountChallanId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        toast.success(response.message);
        fetchData();
        setIsConfimationModalOpen(false);
      } else {
        toast.error(response);
      }
    } catch (error) {
      console.error("Error fetching admission voucher:", error);
    }
  };

  const handleChatWithParentClick = (parentUserId) => {
    openChatWithReceiver(parentUserId);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(registrationsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pupils");
    XLSX.writeFile(workbook, "registrations_data.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    // const logoWidth = 30;
    // const logoHeight = 8;
    // const logoX = (pageWidth - logoWidth) / 2;
    // const logoY = 10;
    // doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Registrations Data";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = 20;
    doc.text(title, titleX, titleY);

    const columns = columnOrder
      .filter((key) => key !== "mrt-row-spacer" && key !== "actions")
      .map((key) => ({ header: columnLabels[key] || key, dataKey: key }));

    const headers = [columns.map((col) => col.header)];

    const bodyData = registrationsData.map((row) =>
      columns.map((col) => row[col.dataKey] ?? "")
    );

    doc.autoTable({
      head: headers,
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
        halign: "center",
      },
      styles: {
        // fontSize: 8,
        // cellPadding: 4,
        overflow: "linebreak",
        // minCellHeight: 20,
      },
    });

    doc.save("registrations_data.pdf");
  };

  const redirectToParentRegistrationForm = async (userId) => {
    navigate(`/registration-form?userId=${userId}`);
  };

  useEffect(() => {
    const fetchClassesByCenterId = async () => {
      try {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setClassesData(response);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };
    fetchClassesByCenterId();
  }, []);

  useEffect(() => {
    if (assessmentDate) {
      fetchAssessmentSLots();
    }
  }, [assessmentDate]);

  const fetchAssessmentSLots = async () => {
    try {
      const response = await get(
        `CommonSettings/GetTimeSlotByDateAndSlotTypeAsync?date=${assessmentDate}&slotType=${"Assessment"}&centerId=${centerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAssessmentData(response?.timeSlot);
      setValue("assessmentSlotId", null);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const openAssessmentDateModal = async (row) => {
    setSelectedRow(row);
    setIsAssessmentDateModalVisible(true);
  };

  const openScheduleInterviewModal = async (row) => {
    setSelectedRow(row);
    setIsScheduleInterviewModalVisible(true);
  };

  const openInterviewModal = async (row) => {
    setSelectedRow(row);
    setIsInterviewModalVisible(true);
  };

  const closeModals = () => {
    setIsAssessmentDateModalVisible(false);
    setSelectedRow(null);
  };

  const handleAssessmentDateSubmit = async () => {
    const isValid = await trigger([
      "assessmentDate",
      "assessmentSlotId",
      "communicationRemarks",
    ]);
    if (!isValid) return;

    setIsLoading(true);
    const formValues = getValues();
    const formData = {
      id: selectedRow.id,
      assessmentDate: formValues.assessmentDate,
      communicationRemarks: formValues.communicationRemarks,
      isCommunicatedToGuardian: true,
      centerClassId: formValues.centerClassId?.value,
      assessmentSlotId: formValues.assessmentSlotId?.value,
      updatedBy: localStorage.getItem("userId"),
    };

    try {
      const response = await post(
        `Student/UpdateFirstRegistrationAssessmentDate`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
      } else {
        toast.error(response.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    } finally {
      setIsLoading(false);
    }
    closeModals();
  };

  const handlePrintChallanAction = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }
    setLoading(true);
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(
        `${API_BASE_URL}Student/GenerateInvoice?FirstRegistrationId=${firstRegistrationId}&createdBy=${userId}`,
        { method: "GET", headers: { Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      getRegistrationsList();
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error("Error opening the invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewRegReceiptChallan = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }
    setLoading(true);
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(
        `${API_BASE_URL}Student/ViewRegReceiptChallan?FirstRegistrationId=${firstRegistrationId}`,
        { method: "GET", headers: { Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      getRegistrationsList();
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error("Error opening the invoice:", error);
    } finally {
      setLoading(false);
    }
  };
  // New function to handle RegPaymentProofModal submission
  const handleRegPaymentProofSubmit = async (formData) => {
    setLoading(true);
    try {
      const nextStepId =
        workflowSteps[formData.studentFirstRegistrationId]?.id || 0;
      const endpoint =
        paymentProofType === "registration"
          ? "Student/AddStudentRegistrationChallanReceipt"
          : "Student/AddStudentAdmissionChallanReceipt";
      const notificationEvent =
        paymentProofType === "registration"
          ? NotificationEventTypes.UPLOAD
          : NotificationEventTypes.ATTACH;

      const payload = {
        ReceiptName: formData.receiptName,
        Base64Url: formData.base64Url,
        StudentFirstRegistrationId: formData.studentFirstRegistrationId,
        createdBy: localStorage.getItem("userId"),
        FormId: 82,
        NotificationEventTypeIds: notificationEvent.toString(),
        Workflow: {
          WorkflowProcessId: WorkflowProcessIds.NewRegistration,
          WorkflowStepId: nextStepId,
          DBObjectId: DBObjectIds.StudentFirstRegistrations,
          DBObjectLocationId: formData.studentFirstRegistrationId,
          createdBy: Number(userId),
          Comments: "",
        },
      };

      const response = await post(endpoint, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        setShowRegPaymentProofModal(false);
      } else {
        toast.error(response.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to upload payment proof");
    } finally {
      setLoading(false);
    }
  };
  const handleViewAdmissionReceiptChallan = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }
    setLoading(true);
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(
        `${API_BASE_URL}Student/ViewAdmReceiptChallan?FirstRegistrationId=${firstRegistrationId}`,
        { method: "GET", headers: { Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      getRegistrationsList();
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error("Error opening the invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePayRegChallanClick = async (row, workflow) => {
    try {
      const queryString = `studentFirstRegistrationId=${row.id}&WorkflowProcessId=${workflow.WorkflowProcessId}&WorkflowStepId=${workflow.WorkflowStepId}&DBObjectId=${workflow.DBObjectId}&DBObjectLocationId=${workflow.DBObjectLocationId}&createdBy=${userId}`;
      const response = await get(
        `AssessmentType/GetRegistartionVoucherByRegIdAsync?${queryString}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        setPayRegModalData(response?.registrationVoucher);
        setShowPayRegModal(true);
      } else {
        console.error("Error fetching fee details");
      }
    } catch (error) {
      console.error("Error fetching registration voucher:", error);
    }
  };

  const submitPayRegChallan = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    const currentDate = new Date().toISOString();
    const formDataWithPaymentInfo = {
      ...formData,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      paidBy: localStorage.getItem("userId"),
      isPaid: true,
      paymentDate: currentDate,
      id: formData.id,
      voucherNo: formData.voucherNo,
      Workflow: {
        WorkflowProcessId: workflowParams.Workflow.WorkflowProcessId,
        WorkflowStepId: workflowParams.Workflow.WorkflowStepId,
        DBObjectId: workflowParams.Workflow.DBObjectId,
        DBObjectLocationId: workflowParams.Workflow.DBObjectLocationId,
        createdBy: Number(userId),
        Comments: "",
      },
    };

    // console.log(formDataWithPaymentInfo);
    // return;

    try {
      const response = await post(
        `AssessmentType/UpdateRegistartionVoucherPaidAsync`,
        formDataWithPaymentInfo,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setShowPayRegModal(false);
        setTriggerRerender((prev) => !prev);
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const handlePayAdmissionChallanClick = async (row, workflow) => {
    try {
      const queryString = `studentFirstRegistrationId=${row.id}&WorkflowProcessId=${workflow.WorkflowProcessId}&WorkflowStepId=${workflow.WorkflowStepId}&DBObjectId=${workflow.DBObjectId}&DBObjectLocationId=${workflow.DBObjectLocationId}&createdBy=${userId}`;
      const response = await get(
        `AssessmentType/GetAdmissionVoucherByRegistartionNoAsync?${queryString}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        setPayAdmissionModalData(response?.admissionVoucher[0]);
        setShowPayAdmissionModal(true);
      } else {
        console.error("Error fetching fee details");
      }
    } catch (error) {
      console.error("Error fetching admission voucher:", error);
    }
  };

  const submitPayAdmissionChallan = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    const currentDate = new Date().toISOString();
    const formDataWithPaymentInfo = {
      ...formData,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      paidBy: localStorage.getItem("userId"),
      isPaid: true,
      paymentDate: currentDate,
      id: formData.id,
      voucherNo: formData.voucherNo,
      Workflow: {
        WorkflowProcessId: workflowParams.Workflow.WorkflowProcessId,
        WorkflowStepId: workflowParams.Workflow.WorkflowStepId,
        DBObjectId: workflowParams.Workflow.DBObjectId,
        DBObjectLocationId: workflowParams.Workflow.DBObjectLocationId,
        createdBy: Number(userId),
        Comments: "",
      },
    };

    try {
      const response = await post(
        `AssessmentType/UpdateAdmissionVoucherPaidAsync`,
        formDataWithPaymentInfo,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setShowPayAdmissionModal(false);
        setTriggerRerender((prev) => !prev);
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const openAssessmentMarksModal = (row) => {
    setSelectedRow(row);
    setIsAssessmentMarksModalVisible(true);
  };

  const openReviewDetailsModal = (row, mode = "acceptance") => {
    setSelectedRow(row);
    setModalMode(mode);
    setIsReviewDetailsModalVisible(true);
  };

  const openStatusDetailsModal = (row, mode = "acceptance") => {
    setSelectedRow(row);
    setModalMode(mode);
    setIsStatusModalVisible(true);
  };

  const openNewRegistrationModel = (row) => {
    setSelectedRow(row);
    setNewRegistrationModel(true);
  };
  // Update handleAttachmentFileChange to use RegPaymentProofModal
  const handleAttachmentFileChange = async (index) => {
    setRegPaymentProofModalData({ id: index });
    setPaymentProofType("registration");
    setShowRegPaymentProofModal(true);
  };
  const handlePrintAdmissionChallanAction = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }
    setLoading(true);
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(
        `${API_BASE_URL}Student/GenerateAdmissionChallan?FirstRegistrationId=${firstRegistrationId}&createdBy=${userId}`,
        { method: "GET", headers: { Authorization: `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
      getRegistrationsList();
    } catch (error) {
      console.error("Error opening the invoice:", error);
    } finally {
      setLoading(false);
    }
  };
  // Update handleAttachmentAdmissionFileChangeA to use RegPaymentProofModal
  const handleAttachmentAdmissionFileChangeA = async (index) => {
    setRegPaymentProofModalData({ id: index });
    setPaymentProofType("admission");
    setShowRegPaymentProofModal(true);
  };
  const handleCreateStudentClick = async (registartionNo) => {
    navigate(`/student-form?voucherNo=${registartionNo}`);
  };

  const handleUnknownStep = (row) => {
    toast.warn(
      `Action "${workflowSteps[row.id]?.name || "Unknown"}" not implemented`
    );
  };

  const actionHandlers = {
    "Application Review": [
      {
        name: "actionHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: {
              WorkflowProcessId: WorkflowProcessIds.NewRegistration,
              WorkflowStepId: nextStepId,
              DBObjectId: DBObjectIds.StudentFirstRegistrations,
              DBObjectLocationId: param.id,
              createdBy: Number(userId),
              Comments: "",
            },
          }));

          navigateToReview(param.userId);
        },
        icon: "fas fa-eye",
        disabled: () => false,
        param: (row) => row,
        tooltip: "Application Review",
      },
    ],
    "Registration Challan": [
      {
        name: "Print Registration Challan",
        handler: (row) => handlePrintChallanAction(row.id),
        icon: "fas fa-print",
        disabled: () => false,
        param: (row) => row,
        tooltip: "Print Registration Challan",
      },
      {
        name: "Upload Registration Payment Proof",
        handler: (row) => handleAttachmentFileChange(row.id),
        icon: "fas fa-upload",
        disabled: (row) =>
          row.registrationVoucherNo === "" || row.isPaidRegistration,
        param: (row) => row,
        tooltip: (row) =>
          row.receiptFilePath == ""
            ? "Re-upload Registration Payment Proof"
            : "Upload Registration Payment Proof",
      },
      {
        name: "View Receipt",
        handler: (row) => handlePrintChallanAction(row.id),
        icon: "fas fa-receipt",
        disabled: (row) => !row.receiptFilePath,
        param: (row) => row,
        tooltip: "View Receipt",
        href: (row) =>
          `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${row.receiptFilePath}`,
      },
    ],
    "Account Verification": [
      {
        name: "printHandler",
        handler: (param) => {
          handlePrintChallanAction(param.id);
        },
        icon: "fas fa-print",
        disabled: () => false,
        param: (row) => row,
        tooltip: "Print Registration Challan",
      },
      {
        name: "viewHandler",
        handler: (param) => {
          handleViewRegReceiptChallan(param.id);
        },
        icon: "fas fa-receipt",
        disabled: (row) => false,
        param: (row) => row,
        tooltip: "Registration Challan Receipt",
      },
      {
        name: "verificationHandler",
        handler: (param) => {
          VerifyAccountChallan(param.id, 0);
        },
        icon: "fas fa-check-double",
        disabled: (row) => row.isAccountRegChallanVerified,
        param: (row) => row,
        tooltip: "Verify Registration Challan",
      },
      {
        name: "payHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          const workflow = {
            WorkflowProcessId: WorkflowProcessIds.NewRegistration,
            WorkflowStepId: nextStepId,
            DBObjectId: DBObjectIds.StudentFirstRegistrations,
            DBObjectLocationId: param.id,
            createdBy: Number(userId),
            Comments: "",
          };
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: workflow,
          }));
          handlePayRegChallanClick(param, workflow);
        },
        icon: "fas fa-file-invoice-dollar",
        disabled: (row) =>
          !row.isAccountRegChallanVerified || row.isPaidRegistration,
        param: (row) => row,
        tooltip: "Pay Registration Challan",
      },
    ],
    "Assessment Schedule": [
      {
        name: "actionHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: {
              WorkflowProcessId: WorkflowProcessIds.NewRegistration,
              WorkflowStepId: nextStepId,
              DBObjectId: DBObjectIds.StudentFirstRegistrations,
              DBObjectLocationId: param.id,
              createdBy: Number(userId),
              Comments: "",
            },
          }));
          openAssessmentDateModal(param);
        },
        icon: "fas fa-calendar-days",
        disabled: false,
        param: (row) => row,
        tooltip: "Schedule Assessment",
      },
    ],
    "Assessment Remarks": [
      {
        name: "actionHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: {
              WorkflowProcessId: WorkflowProcessIds.NewRegistration,
              WorkflowStepId: nextStepId,
              DBObjectId: DBObjectIds.StudentFirstRegistrations,
              DBObjectLocationId: param.id,
              createdBy: Number(userId),
              Comments: "",
            },
          }));
          openAssessmentMarksModal(param);
        },
        icon: "fas fa-marker",
        disabled: false,
        param: (row) => row,
        tooltip: "Assessment Marks",
      },
    ],
    "Interview Schedule": [
      {
        name: "actionHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: {
              WorkflowProcessId: WorkflowProcessIds.NewRegistration,
              WorkflowStepId: nextStepId,
              DBObjectId: DBObjectIds.StudentFirstRegistrations,
              DBObjectLocationId: param.id,
              createdBy: Number(userId),
              Comments: "",
            },
          }));
          openScheduleInterviewModal(param);
        },
        icon: "fas fa-calendar-days",
        disabled: false,
        param: (row) => row,
        tooltip: "Schedule Interview",
      },
    ],
    "Interview Remarks": [
      {
        name: "actionHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: {
              WorkflowProcessId: WorkflowProcessIds.NewRegistration,
              WorkflowStepId: nextStepId,
              DBObjectId: DBObjectIds.StudentFirstRegistrations,
              DBObjectLocationId: param.id,
              createdBy: Number(userId),
              Comments: "",
            },
          }));
          openInterviewModal(param);
        },
        icon: "fas fa-people-arrows",
        disabled: false,
        param: (row) => row,
        tooltip: "Interview Remarks",
      },
    ],
    "Fee Plan Attachment": [
      {
        name: "actionHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: {
              WorkflowProcessId: WorkflowProcessIds.NewRegistration,
              WorkflowStepId: nextStepId,
              DBObjectId: DBObjectIds.StudentFirstRegistrations,
              DBObjectLocationId: param.id,
              createdBy: Number(userId),
              Comments: "",
            },
          }));
          openReviewDetailsModal(param);
        },
        icon: "fas fa-file-invoice",
        disabled: false,
        param: (row) => row,
        tooltip: "Fee Plan & Concession",
      },
    ],
    "Accounts Approval": [
      {
        name: "actionHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: {
              WorkflowProcessId: WorkflowProcessIds.NewRegistration,
              WorkflowStepId: nextStepId,
              DBObjectId: DBObjectIds.StudentFirstRegistrations,
              DBObjectLocationId: param.id,
              createdBy: Number(userId),
              Comments: "",
            },
          }));
          openReviewDetailsModal(param, "accountsApproval");
        },
        icon: "fas fa-check-circle",
        disabled: false,
        param: (row) => row,
        tooltip: "Accounts Approval",
      },
    ],
    "CEO Approval": [
      {
        name: "actionHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: {
              WorkflowProcessId: WorkflowProcessIds.NewRegistration,
              WorkflowStepId: nextStepId,
              DBObjectId: DBObjectIds.StudentFirstRegistrations,
              DBObjectLocationId: param.id,
              createdBy: Number(userId),
              Comments: "",
            },
          }));
          openReviewDetailsModal(param, "ceoApproval");
        },
        icon: "fas fa-user-tie",
        disabled: false,
        param: (row) => row,
        tooltip: "CEO Approval",
      },
    ],
    "Admission Challan": [
      {
        name: "actionHandler",
        handler: (param) => {
          handlePrintAdmissionChallanAction(param.id);
        },
        icon: "fas fa-print",
        disabled: () => false,
        param: (row) => row,
        tooltip: "Print Admission Challan",
      },
      {
        name: "Upload Registration Payment Proof",
        handler: (row) => handleAttachmentAdmissionFileChangeA(row.id),
        icon: "fas fa-upload",
        disabled: (row) => row.admissionVoucherNo === "",
        param: (row) => row,
        tooltip: (row) =>
          row.receiptFilePath == ""
            ? "Re-upload Registration Payment Proof"
            : "Upload Registration Payment Proof",
      },
      {
        name: "View Receipt",
        handler: (row) => handlePrintChallanAction(row.id),
        icon: "fas fa-receipt",
        disabled: (row) => !row.admissionReceiptFilePath,
        param: (row) => row,
        tooltip: "View Receipt",
        href: (row) =>
          `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${row.admissionReceiptFilePath}`,
      },
    ],
    "Admission Verification": [
      {
        name: "printHandler",
        handler: (param) => {
          handlePrintAdmissionChallanAction(param.id);
        },
        icon: "fas fa-print",
        disabled: () => false,
        param: (row) => row,
        tooltip: "Print Admission Challan",
      },
      {
        name: "viewHandler",
        handler: (param) => {
          handleViewAdmissionReceiptChallan(param.id);
        },
        icon: "fas fa-receipt",
        disabled: (row) => false,
        param: (row) => row,
        tooltip: "Admission Challan Receipt",
      },
      {
        name: "verificationHandler",
        handler: (param) => {
          VerifyAccountChallan(param.id, 1);
        },
        icon: "fas fa-check-double",
        disabled: (row) => row.isAccountAdmChallanVerified,
        param: (row) => row,
        tooltip: "Verify Admission Challan",
      },
      {
        name: "payHandler",
        handler: (param) => {
          const nextStepId = workflowSteps[param.id]?.id || 0;
          const workflow = {
            WorkflowProcessId: WorkflowProcessIds.NewRegistration,
            WorkflowStepId: nextStepId,
            DBObjectId: DBObjectIds.StudentFirstRegistrations,
            DBObjectLocationId: param.id,
            createdBy: Number(userId),
            Comments: "",
          };
          setWorkflowParams((prev) => ({
            ...prev,
            Workflow: workflow,
          }));
          handlePayAdmissionChallanClick(param, workflow);
        },
        icon: "fas fa-file-invoice-dollar",
        disabled: (row) =>
          !row.isAccountAdmChallanVerified || row.isPaidAdmission,
        param: (row) => row,
        tooltip: "Pay Admission Challan",
      },
    ],
    "Create Student": [
      {
        name: "actionHandler",
        handler: handleCreateStudentClick,
        icon: "fas fa-user-graduate",
        disabled: (row) => !row.isAccepted || !row.isPaidAdmission,
        param: (row) => row.admissionVoucherNo,
        tooltip: "Create Student",
      },
    ],
  };

  const columns = useMemo(
    () => [
      ...columnOrder
        .filter(
          (key) =>
            key !== "mrt-row-spacer" && key !== "actions" && key !== "status"
        )
        .map((key) => ({
          accessorKey: key,
          id: key,
          header: columnLabels[key] || key,
          filterVariant: key.includes("is") ? "checkbox" : "text",
          enableColumnFilter:
            tablePreferences?.columnFilterability?.[key] ?? true,
          enableColumnFilterModes: true,
          filterModeOptions: [
            "contains",
            "startsWith",
            "endsWith",
            "equals",
            "notEquals",
            "greaterThan",
            "lessThan",
            "greaterThanOrEqualTo",
            "lessThanOrEqualTo",
            "between",
            "empty",
            "notEmpty",
          ],
          filterFn:
            filterModes[key] ||
            (key.includes("Id") || key.includes("No") || key.startsWith("is")
              ? "equals"
              : key.includes("Date")
              ? "between"
              : "contains"),
          enableSorting: tablePreferences?.columnSortability?.[key] ?? true,
          size: columnSizing[key] || 150,
          minSize: 50,
          maxSize: 1000,
        })),
      // {
      //   accessorKey: "status",
      //   id: "status",
      //   header: "Status",
      //   filterVariant: "text",
      //   enableColumnFilter: true,
      //   enableColumnFilterModes: true,
      //   filterModeOptions: [
      //     "contains",
      //     "startsWith",
      //     "endsWith",
      //     "equals",
      //     "notEquals",
      //     "empty",
      //     "notEmpty",
      //   ],
      //   filterFn: filterModes["status"] || "contains",
      //   enableSorting: true,
      //   size: 200, // Explicitly set and locked
      //   minSize: 200, // Match size to enforce minimum
      //   // maxSize: 400, // Match size to enforce maximum
      //   enableResizing: true, // Disable resizing to lock width
      //   pinned: "right",
      //   Cell: ({ row }) => {
      //     const statuses = workflowStatus[row.original.id] || [];
      //     const latestStatus = statuses.reduce((latest, status) => {
      //       return new Date(status.StepPerformedDate) >
      //         new Date(latest.StepPerformedDate || 0)
      //         ? status
      //         : latest;
      //     }, {});
      //     const openStatusModal = () => {
      //       setSelectedRowId(row.original.id);
      //       setIsStatusModalOpen(true);
      //     };

      //     return (
      //       <>
      //         {latestStatus.StepName ? (
      //           <>
      //             <button
      //               type="button"
      //               className="btn p-0 me-1"
      //               data-tooltip-id="global-tooltip"
      //               data-tooltip-content="Status Overview"
      //               onClick={openStatusModal}
      //             >
      //               <i className="text-primary fs-8 fas fa-info-circle"></i>
      //             </button>
      //             {latestStatus.StepName}
      //           </>
      //         ) : (
      //           "N/A"
      //         )}
      //       </>
      //     );
      //   },
      // },
      {
        accessorKey: "status",
        id: "status",
        header: "Last Step",
        filterVariant: "text",
        enableColumnFilter: true,
        enableColumnFilterModes: true,
        filterModeOptions: [
          "contains",
          "startsWith",
          "endsWith",
          "equals",
          "notEquals",
          "empty",
          "notEmpty",
        ],
        filterFn: (row, columnId, filterValue) => {
          const statuses = workflowStatus[row.original.id] || [];
          const latestStatus = statuses.reduce((latest, status) => {
            return new Date(status.StepPerformedDate) >
              new Date(latest.StepPerformedDate || 0)
              ? status
              : latest;
          }, {});
          const nextStep = nextSteps[row.original.id] || {};
          const value =
            nextStep.nextStepAction ||
            latestStatus.StepName ||
            "Application Review Pending";
          return value.toLowerCase().includes(filterValue.toLowerCase());
        },
        enableSorting: true,
        size: 250,
        minSize: 250,
        enableResizing: true,
        pinned: "right",
        Cell: ({ row }) => {
          const statuses = workflowStatus[row.original.id] || [];
          const latestStatus = statuses.reduce((latest, status) => {
            return new Date(status.StepPerformedDate) >
              new Date(latest.StepPerformedDate || 0)
              ? status
              : latest;
          }, {});
          const nextStep = nextSteps[row.original.id] || {};
          const openStatusModal = () => {
            setSelectedRowId(row.original.id);
            setIsStatusModalOpen(true);
          };

          return (
            <>
              {latestStatus.StepName || nextStep.nextStepAction ? (
                <>
                  <button
                    type="button"
                    className="btn p-0 me-1"
                    data-tooltip-id="global-tooltip"
                    data-tooltip-content="Status Overview"
                    onClick={openStatusModal}
                  >
                    <i className="text-primary fs-8 fas fa-info-circle"></i>
                  </button>
                  <div className="d-flex flex-column">
                    <div className="">
                      {nextStep.nextStepAction ? (
                        <>{nextStep.nextStepAction}</>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : (
                <div className="">Application Review Pending</div>
              )}
            </>
          );
        },
      },
      {
        accessorKey: "status",
        id: "status",
        header: "Next Step",
        filterVariant: "text",
        enableColumnFilter: true,
        enableColumnFilterModes: true,
        filterModeOptions: [
          "contains",
          "startsWith",
          "endsWith",
          "equals",
          "notEquals",
          "empty",
          "notEmpty",
        ],
        filterFn: (row, columnId, filterValue) => {
          const statuses = workflowStatus[row.original.id] || [];
          const latestStatus = statuses.reduce((latest, status) => {
            return new Date(status.StepPerformedDate) >
              new Date(latest.StepPerformedDate || 0)
              ? status
              : latest;
          }, {});
          const nextStep = nextSteps[row.original.id] || {};
          const value =
            nextStep.nextStepAction ||
            latestStatus.StepName ||
            "Application Review Pending";
          return value.toLowerCase().includes(filterValue.toLowerCase());
        },
        enableSorting: true,
        size: 250,
        minSize: 250,
        enableResizing: true,
        pinned: "right",
        Cell: ({ row }) => {
          const statuses = workflowStatus[row.original.id] || [];
          const latestStatus = statuses.reduce((latest, status) => {
            return new Date(status.StepPerformedDate) >
              new Date(latest.StepPerformedDate || 0)
              ? status
              : latest;
          }, {});
          const nextStep = nextSteps[row.original.id] || {};
          const openStatusModal = () => {
            setSelectedRowId(row.original.id);
            setIsStatusModalOpen(true);
          };

          return (
            <>
              {latestStatus.StepName || nextStep.nextStepAction ? (
                <>
                  <button
                    type="button"
                    className="btn p-0 me-1"
                    data-tooltip-id="global-tooltip"
                    data-tooltip-content="Status Overview"
                    onClick={openStatusModal}
                  >
                    <i className="text-primary fs-8 fas fa-info-circle"></i>
                  </button>
                  <div className="d-flex flex-column">
                    <div className="">
                      {nextStep.nextStepAction ? (
                        <>{nextStep.nextStepAction}</>
                      ) : null}
                    </div>
                  </div>
                </>
              ) : (
                <div className="">Application Review Pending</div>
              )}
            </>
          );
        },
      },
      {
        accessorKey: "actions",
        id: "actions",
        header: "Actions",
        enableColumnFilter: false,
        enableSorting: false,
        enableHiding: false,
        enableResizing: false,
        enablePinning: true,
        pinned: "right",
        size: 150,
        Cell: ({ row }) => {
          const statuses = workflowStatus[row.original.id] || [];
          const isWorkflowEnded = statuses.some((status) => status.IsEnd);
          const nextStep = workflowSteps[row.original.id]?.name || "";

          if (roleId == "3" || (roleId == "2" && isWorkflowEnded)) {
            const actions = actionHandlers["Create Student"] || [];
            return (
              <div className="d-flex align-items-center gap-2">
                {actions.map((config, index) => (
                  <button
                    key={`${config.name}-${index}`}
                    type="button"
                    className="btn custom-disabled-btn border-0 p-0"
                    data-tooltip-id="global-tooltip"
                    data-tooltip-content={config.tooltip}
                    onClick={() => config.handler(config.param(row.original))}
                    disabled={
                      typeof config.disabled === "function"
                        ? config.disabled(row.original)
                        : config.disabled
                    }
                  >
                    <i className={`${config.icon} me-1 fs-9`}></i>
                  </button>
                ))}
              </div>
            );
          }

          const actions = actionHandlers[nextStep] || [
            {
              name: "actionHandler",
              handler: handleUnknownStep,
              icon: "",
              disabled: () => true,
              param: (row) => row,
              tooltip: "",
            },
          ];

          return (
            <div className="d-flex align-items-center gap-2">
              {actions.map((config, index) => (
                <button
                  key={`${config.name}-${index}`}
                  type="button"
                  className="btn custom-disabled-btn border-0 p-0"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content={config.tooltip}
                  onClick={() => config.handler(config.param(row.original))}
                  disabled={
                    typeof config.disabled === "function"
                      ? config.disabled(row.original)
                      : config.disabled
                  }
                >
                  <i className={`${config.icon} me-1 fs-9`}></i>
                </button>
              ))}
            </div>
          );
        },
      },
    ],
    [
      columnOrder,
      columnLabels,
      tablePreferences,
      filterModes,
      columnSizing,
      workflowSteps,
      workflowStatus,
    ]
  );

  // if (isLoading) {
  //   return <i className="fas fa-spinner"></i>;
  // }

  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center mb-3">
        <h2 className="page-heading fs-7">All Registrations</h2>
        {roleId == "3" ||
          (roleId == "2" && (
            <div className="d-flex align-items-center gap-2">
              <div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => openNewRegistrationModel()}
                >
                  New Registration
                </button>
              </div>
            </div>
          ))}
      </div>
      <div className="card">
        <div className="card-body">
          <div className="custom-mrt-table-wrapper">
            <MaterialReactTable
              columns={columns}
              data={registrationsData}
              enableColumnFilters
              enableGlobalFilter
              enableColumnDragging
              enableColumnResizing
              enableHiding
              enableColumnOrdering
              enableSorting
              enableStickyHeader
              enableColumnFilterModes
              defaultColumn={{ minSize: 50, maxSize: 1000, size: 150 }}
              initialState={{
                showColumnFilters: true,
                columnOrder,
                columnVisibility,
                sorting,
                columnSizing,
                columnFilters,
                density: "compact",
                columnPinning: { right: ["status", "actions"] },
              }}
              state={{
                columnOrder,
                columnVisibility,
                sorting,
                columnSizing,
                columnFilters,
              }}
              onColumnOrderChange={(newOrder) =>
                setColumnOrder(
                  newOrder.filter((key) => key !== "mrt-row-spacer")
                )
              }
              onColumnVisibilityChange={setColumnVisibility}
              onSortingChange={(updater) => {
                const newSorting =
                  typeof updater === "function" ? updater(sorting) : updater;
                setSorting(newSorting.slice(0, 1));
              }}
              onColumnSizingChange={(updater) => {
                const newSizing =
                  typeof updater === "function"
                    ? updater(columnSizing)
                    : updater;
                setColumnSizing(
                  Object.fromEntries(
                    Object.entries(newSizing).filter(
                      ([key]) => key !== "mrt-row-spacer"
                    )
                  )
                );
              }}
              onColumnFiltersChange={(updater) => {
                const newFilters =
                  typeof updater === "function"
                    ? updater(columnFilters)
                    : updater;
                setColumnFilters(
                  newFilters.filter((filter) => filter.id !== "mrt-row-spacer")
                );
                const newFilterModes = { ...filterModes };
                newFilters.forEach((filter) => {
                  if (filter.filterFn && filter.id !== "mrt-row-spacer") {
                    newFilterModes[filter.id] = filter.filterFn;
                  }
                });
                setFilterModes(newFilterModes);
              }}
              muiTableProps={{ className: "custom-mrt-table" }}
              muiTableHeadCellProps={{
                className: "custom-mrt-table-head-cell",
              }}
              muiTableBodyCellProps={{
                className: "custom-mrt-table-body-cell",
                // style: { backgroundColor: "#fff" }, // Prevent cell background override
              }}
              muiTableBodyRowProps={({ row }) => ({
                sx: {
                  backgroundColor:
                    row.original.isCenterSubmit == false ? "#fffec0" : "#fff",
                },
              })}
              renderTopToolbarCustomActions={({ table }) => (
                <div className="d-flex gap-1 align-items-center">
                  <button
                    type="button"
                    className="btn btn-with-icon-and-tooltip"
                    data-tooltip-id="global-tooltip"
                    data-tooltip-content="Save Preferences"
                    onClick={saveTablePreferences}
                  >
                    <i className="text-primary fs-7 fas fa-save"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-with-icon-and-tooltip"
                    data-tooltip-id="global-tooltip"
                    data-tooltip-content="Export to Excel"
                    onClick={exportToExcel}
                  >
                    <i className="text-success fs-7 fas fa-file-excel"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-with-icon-and-tooltip"
                    data-tooltip-id="global-tooltip"
                    data-tooltip-content="Export to PDF"
                    onClick={exportToPDF}
                  >
                    <i className="text-danger fs-7 fas fa-file-pdf"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-with-icon-and-tooltip"
                    data-tooltip-id="global-tooltip"
                    data-tooltip-content="Open Stages Overview"
                    onClick={() => setShowPopup(true)}
                  >
                    <i className="text-info fs-7 fas fa-chart-bar"></i>
                  </button>
                </div>
              )}
            />
          </div>
        </div>
      </div>

      {isStatusModalOpen && selectedRowId && (
        <div
          className="modal"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeStatusModal}
        >
          <div className="modal-dialog modal-xl">
            <div
              className="modal-content"
              style={{
                backgroundColor: "white",
                maxHeight: "80vh",
                overflowY: "auto",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h5 className="mb-0">Status Overview</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeStatusModal}
                ></button>
              </div>
              <div className="modal-body">
                <table className="table custom-table table-bordered">
                  <thead>
                    <tr>
                      <th>Step No.</th>
                      <th>Step Name</th>
                      <th>Status</th>
                      <th>Remarks</th>
                      <th>Performed By</th>
                      <th>Date/Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(workflowStatus[selectedRowId] || []).map(
                      (status, index) => (
                        <tr key={index}>
                          <td>{status.StepOrder}</td>
                          <td>{status.StepName}</td>
                          <td>{status.StepStatus}</td>
                          <td>{status.StepRemarks}</td>
                          <td>{status.StepPerformedBy}</td>
                          <td>
                            {new Date(
                              status.StepPerformedDate
                            ).toLocaleString()}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {isScheduleInterviewModalVisible && (
        <ScheduleInterviewModal
          firstRegistrationId={selectedRow.id}
          code={selectedRow.code}
          onClose={() => setIsScheduleInterviewModalVisible(false)}
          refreshOnSubmitSuccess={getRegistrationsList}
        />
      )}
      {isInterviewModalVisible && (
        <InterviewModal
          firstRegistrationId={selectedRow.id}
          interviewData={selectedRow}
          onClose={() => setIsInterviewModalVisible(false)}
          refreshOnSubmitSuccess={getRegistrationsList}
        />
      )}
      {showPayRegModal && (
        <PayRegChallanModal
          title="Pay Registration Challan"
          onClose={() => setShowPayRegModal(false)}
          regModalData={payRegModalData}
          payRegChallan={submitPayRegChallan}
        />
      )}
      {showPayAdmissionModal && (
        <PayAdmissionChallanModal
          title="Pay Admission Challan"
          onClose={() => setShowPayAdmissionModal(false)}
          admissionModalData={payAdmissionModalData}
          payAdmissionChallan={submitPayAdmissionChallan}
        />
      )}
      {isAssessmentDateModalVisible && (
        <AssessmentDateModal
          centerId={centerId}
          firstRegistrationId={selectedRow.id}
          code={selectedRow.code}
          selectedClass={selectedRow.centerClassId}
          onClose={() => setIsAssessmentDateModalVisible(false)}
          refreshOnSubmitSuccess={getRegistrationsList}
        />
      )}
      {isAssessmentMarksModalVisible && (
        <AssessmentMarksModal
          centerId={centerId}
          classId={selectedRow?.centerClassId}
          firstRegistrationId={selectedRow.id}
          onClose={() => setIsAssessmentMarksModalVisible(false)}
          refreshOnSubmitSuccess={getRegistrationsList}
        />
      )}
      {isReviewDetailsModalVisible && (
        <ReviewDetailsModal
          selectedRowData={selectedRow}
          firstRegistrationId={selectedRow.id}
          onClose={() => setIsReviewDetailsModalVisible(false)}
          refreshOnSubmitSuccess={getRegistrationsList}
          mode={modalMode}
        />
      )}
      {isStatusModalVisible && (
        <StatusRegistrationModal
          selectedRowData={selectedRow}
          onClose={() => setIsStatusModalVisible(false)}
          refreshOnSubmitSuccess={getRegistrationsList}
        />
      )}
      {isNewRegistrationModel && (
        <CampusNewRegistrationModel
          onClose={() => setNewRegistrationModel(false)}
          refreshOnSubmitSuccess={redirectToParentRegistrationForm}
        />
      )}
      {isConfimationModalOpen && (
        <AskConfirmationModal
          handleClose={handleCloseModal}
          handleConfirm={VerifyAccountChallanA}
          message="Are you sure you want to Verify this Challan?"
        />
      )}
      {showPopup && (
        <StagePopup
          registrationsData={registrationsData}
          workflowStatus={workflowStatus}
          nextSteps={nextSteps}
          onClose={() => setShowPopup(false)}
        />
      )}
      {showRegPaymentProofModal && (
        <RegPaymentProofModal
          title={
            paymentProofType === "registration"
              ? "Registration Payment Proof"
              : "Admission Payment Proof"
          }
          onClose={() => setShowRegPaymentProofModal(false)}
          modalData={regPaymentProofModalData}
          submitData={handleRegPaymentProofSubmit}
        />
      )}
      {loading && <FullScreenLoader />}
    </>
  );
}

export default RegistrationsList;
